<div>
  <div
    class="row breadcrumb-wrapper"
    style="margin-top: 120px"
    *ngIf="showBreadCrumb"
  >
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-breadcrumb [data]="breadcrumbdata"></app-breadcrumb>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="bannerCarousel" class="bannerCarousel position-relative">
    <ng-container *ngIf="imageUrls?.length === 0; else loadingContent">
      <div *ngFor="let item of skeletonService.generateFake(1); let i = index">
        <ngx-skeleton height="362px"></ngx-skeleton>
      </div>
    </ng-container>


      <img
      [src]='environment1 + "assets/images/Square-T-skyblue.png"'
      class="t-image"
      alt="T"
    />
    <div class="horizontal-line"></div>
    <div class="vertical-line"></div>
    <div class="bottom-horizontal-line"></div>
    <div class="bottom-vertical-line"></div>


    <ng-template #loadingContent>
      <owl-carousel-o [options]="customOptionsForBanner">
        <ng-container *ngFor="let item of imageUrls">
          <ng-template carouselSlide [id]="item.id">
            <a (click)="GetTest(item)" [ngStyle]="{ cursor: 'pointer' }">
              <div class="top-banner-wrapper d-flex justify-content-center">
                <img
                  [src]="cfrnt_url + item.path"
                  class="active imgLarge"
                  alt=""
                  loading="lazy"
                  style="height: 362px"
                />
              </div>
            </a>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </ng-template>
  </div>
  <div class="category container position-relative">


    <div class="row justify-content-center" style="margin-top: 25px">
      <div
        class="col-lg-6 col-md-6 col-xl-6 col-xs-6 col-6 mt-2"
        *ngIf="videoData && videoData?.length > 0"
      >
        <h2>Brand Videos</h2>
        <div class="ratio ratio-16x9 youtubeVideos">
          <ngx-lite-youtube
            [videoId]="getVideoId(videoData[0].yt_url)"
            class="rounded"
          >
            {{ videoData[0].yt_url }}</ngx-lite-youtube
          >
        </div>
      </div>
      <div
        class="col-lg-6 col-md-6 col-xl-6 mt-2 col-xs-6 col-6"
        *ngIf="videoData && videoData?.length > 0"
      >
        <h2>New Launches</h2>
        <div class="ratio ratio-16x9 youtubeVideos">
          <ngx-lite-youtube
            [videoId]="getVideoId(videoData[0].ryt_url)"
            class="rounded"
          >
            {{ videoData[0].ryt_url }}</ngx-lite-youtube
          >
        </div>
      </div>
    </div>
    <!-- <p>Story</p> -->

  </div>

  <div class="category  container m-0 position-relative">
    <img
    [src]='environment1 + "assets/images/Square-T-skyblue.png"'
    class="logo-image"
    alt="T"
  />
  <div class="line-horizontal-top"></div>
  <div class="line-vertical-top"></div>
  <div class="line-horizontal-bottom"></div>
  <div class="line-vertical-bottom"></div>
  <div class="lower-bottom-line-horizontal-top"></div>
  <div class="middle-verticle-line"></div>



    <div *ngFor="let item of videoData" id="backImg">
      <div class="row mb-5 pe-5 ps-5 ultrs-story" style="padding-top: 90px;"  >
        <div
          class="col-xs-12 col-lg-5 col-md-5 ps-5"
          id="storyImg"
          style="align-items: center"
        >
          <div id="rotate">
            <span class="paragraphdiv">
              <h2 class="mt-2">Tata {{ item.title }} story</h2>
              <!-- {{ item.description }} -->
              <span
                style="font-size: 16px"
                [innerHTML]="item.description"
              ></span>
            </span>
            <div class="row col-12" *ngIf="sub_lob === 'trucks'">
              <div class="col-12">
                <img
                  width="100%"
                  [src]='environment1 + "assets/images/feature.webp"'
                  style="border-radius: 5px; margin: 20px 0px 20px 0px"
                />
              </div>
              <div class="col-0"></div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-lg-7 col-md-7" id="backT">
          <img class="paragraphdiv" [src]="item.path" alt="" />
        </div>
      </div>
    </div>
  </div>

  <!-- <p>Explore view</p> -->
  <div class="container ExploreVariants">
    <h2 *ngFor="let item of videoData">Explore Tata {{ item.title }}</h2>
    <span style="font-size: x-large; color: #27292f">
      Popular {{ videoData[0]?.title }} Variants</span
    >
    <div class="variant-list mt-4" style="display: flex">
      <div
        class="variant"
        *ngFor="let product of varImg | slice : 0 : 6; let i = index"
        style="width: 10pc"
      >
        <div
          class="variant-img-wrapper"
          (click)="getCarouselData(product, i)"
          [ngStyle]="i === activeVariantIndex ? activeVariantStyle : {}"
          *ngFor="let image of product.images"
        >
          <!-- <img
            class="variants"
            [ngStyle]="i === activeVariantIndex ? activeVariantStyle : {}"
            [src]="image.image_url"
            alt="vehicle"
            (click)="getCarouselData(product, i)"
          /> -->
          <img
            class="variants"
            src="https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/BrandImages/{{
              product.default_vc
            }}.webp"
            alt="vehicle"
          />
          <!-- <img class="variants"
            [src]="image.image_url"
            alt="vehicle"  /> -->
        </div>
        <!-- [ngClass]="varientImg.images.includes(image.image_url) ? 'variant active' : ''" -->
        <span class="variant-name" (click)="getCarouselData(product, i)">{{
          product.level4_ppl_display_name
        }}</span>
      </div>
    </div>
    <div>
      <ngx-slick-carousel
        #slickHLModal2="slick-carousel"
        class="carousel thumbs d-none"
        [config]="firstslider"
      >
        <div ngxSlickItem *ngFor="let item of varientImg.images" class="item">
          <img [src]="item.image_url" alt="vehicle" loading="lazy" />
        </div>
      </ngx-slick-carousel>
      <div class="d-flex justify-content-center mt-5">
        <ngx-slick-carousel
          #slickHLModal3="slick-carousel"
          class="carousel secondSlider popimagepreview gallery2"
          style="width: 80%"
          [config]="secondslider"
        >
          <div ngxSlickItem *ngFor="let item of varientImg.images" class="item">
            <img
              style="
                padding: 20px;
                z-index: 1;
                position: relative;
                border-radius: 5pc;
              "
              [src]="item.image_url"
              alt="vehicle"
              loading="lazy"
            />
            <!-- <div class="ellipse" style="margin-bottom: 16px"></div> -->
          </div>
        </ngx-slick-carousel>
      </div>
      <ng-template #content let-c="close" let-d="dismiss">
        <div class="modal-dialog modal-fullscreen" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <app-conf-carousel
                *ngIf="show3dModel"
                [vc_number]="newFuelType.vehicle_number"
                (showModel)="closeModal()"
                [lobName]="loBname"
                [pl] ="pl"
              >
              </app-conf-carousel>

              <div class="conf-3d-progress">
                <p id="conf-progress-percentage">0%</p>
                <img
                  id="conf-progress-img"
                  src="{{ this.confAWSUrlStr }}/common/loading.svg"
                />
              </div>
              <!-- [vc_number]="vc_no" -->
            </div>
          </div>
        </div>
      </ng-template>

      <div
        class="imgagesd mt-1"
        *ngFor="let item of videoData"
        style="display: flex; justify-content: center; gap: 2px"
      >
        <button
          type="button"
          class="btn btn-primary text-ellipsis btn-lg btn-grad-primary btn-brand"
          data-toggle="tooltip"
          data-placement="top"
          (click)="ViewProductList(item)"
          aria-pressed="false"
          autocomplete="off"
        >
          Explore All
        </button>
        <button
          type="button"
          class="btn btn-primary text-ellipsis btn-lg btn-grad-primary btn-brand"
          *ngIf="showModalButton"
          aria-pressed="false"
          autocomplete="off"
          alt="view360"
          (click)="open360View(content)"
        >
          360&deg; Viewer
        </button>
      </div>
    </div>
  </div>
  <div>
    <app-brand-card
      [brand]="brand"
      [getLob]="lob"
      [getPpl]="ppl"
      [getpl]="pl"
      [columnFive]="column_Five"
    ></app-brand-card>
  </div>
  <!-- <div>
    <app-customer-testimonial></app-customer-testimonial>
  </div> -->
  <section class="container">
    <div class="plp-configure-wrapper pt-5 pb-5">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h1>Not sure which CV to buy?</h1>
          <p class="mb-4">
            Let us help you find the perfect CV for your application
          </p>
          <button
            class="btn btn-primary btn-grad-primary ps-5 pe-5 btn-height button-txt-desktop"
            data-toggle="tooltip"
            data-placement="top"
            title="Click here to Build your own vehicle"
            [routerLink]="'/configurator-home'"
          >
            Build your own vehicle
          </button>
        </div>
      </div>
    </div>
  </section>
</div>
